import React from 'react'
import './section-info-promo.scss';
import Redirect from '../../../shared/components/atoms/redirect/redirect';
import ListRichText from '../../atoms/list-rich-text/list-rich-text';
import GalleryCarrousel from '../../atoms/gallery-carrousel/gallery-carrousel';
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import iconArrow from '../../../shared/assets/images/icons/icon-arrow-left.svg';
import parseFecha from '../../../shared/utils/parseFecha';
import SharedSocial from '../../atoms/shared-social/shared-social';
import siteUrl from '../../../shared/utils/siteUrl';
import SliderBannerGalery from '../../../shared/components/atoms/slider-galery/slider-banner-galery';
import iconDataTime from '../../../shared/assets/images/icons/data-time.svg';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { useState, useEffect } from 'react';

const SectionInfoPromo = props => {
    const { promo } = props;
    const { fechaDeInicio, fechaDeFin } = promo;
    const [expired, setExpired] = useState(false)
    
    let fechaS = fechaDeFin.split("-")
    let fechaFinFormat = new Date(`${fechaS[1]}/${fechaS[2]}/${fechaS[0]}`)
    let today = new Date()
    let todayFormat = new Date(`${today.getMonth()+1}/${today.getDate()}/${today.getFullYear()}`)
  
    useEffect(() => {
        HandleExpired()
    }, [])
    
    const HandleExpired = () => {              
       if(fechaFinFormat < todayFormat){
            setExpired(true)
       }      
    }
    
    const backLink = () => ( 
        <Redirect url="promociones/" className="link back-button">
            <img src={ iconArrow } alt="icon back"></img>
            <span>Volver</span>
        </Redirect> 
    )   
    const parseHorario = () => {
        return `Desde el ${ parseFecha(fechaDeInicio) } Hasta el ${ parseFecha(fechaDeFin) }.`;
    }

    

    return (
        <div className="o-section-info-promo">
            <div className="o-section-promo_breadcrumb">
                <Breadcrumb />
            </div>
            <div className="o-section-promo_back-desktop">
                { backLink() }
            </div>
            <div className="o-section-info-promo_row">
                
                <div className={`o-section-info-promo_column-left ${ expired ? 'expired' : ''}`}>
                    
                    { promo.bannerSlider ? <SliderBannerGalery banner={promo.bannerSlider} logo={promo.logo} promo disabled={expired}/> 
                     :
                     <GalleryCarrousel imagenes={ promo.imgenes } logo={ promo.logo }/>
                    }
                    
                </div>
                <div className="o-section-info-promo_column-right">
                    <div className="o-section-promo_back-mobile">
                        { backLink() }
                    </div>
                    <h1 className={`o-section-info-promo_title ${ expired ? 'expired' : ''}`}>{ promo.titulo }</h1>
                    {
                        !expired ? 
                            <span className="o-section-info-promo_subtitle">{ parseHorario() }</span> 
                            : 
                            <div className="o-section-info-promo_expired">                            
                                <img className="o-section-info-promo_expired-icon" src={ iconDataTime } alt="icon data time" />
                                <span className="o-section-info-promo_expired-text">Promoción Vencida</span>
                            </div>
                    }          
                    
                    <p className={`o-section-info-promo_description ${ expired ? 'expired' : ''}`}>
                        { documentToReactComponents(JSON.parse(promo.descripcion.raw))}
                    </p>
                                  
                    {/*
                    <div className={`o-section-info-promo_description ${ expired ? 'expired' : ''}`}>
                        <ListRichText info={ promo.descripcion.raw }/>
                    </div>
                    */}
                    {
                        promo.tituloBeneficios && 
                        <h2 className={`o-section-info-promo_title-secundary custom-h h3 ${ expired ? 'expired' : ''}`}>{ promo.tituloBeneficios }</h2>
                    }
                    {
                        promo.beneficios &&
                        <div className={`o-section-info-promo_text-secundary ${ expired ? 'expired' : ''}`}>
                            <ListRichText info={ promo.beneficios.raw }/>
                        </div>
                    }
                    {/*
                        (promo.enlaceBotonSecundario && !expired) ?
                        <Redirect url={ promo.enlaceBotonSecundario } className="link" >
                            { promo.textoBotonSecundario }
                        </Redirect> : <div className="space"></div>
                    */}
                    {
                        (promo.textoButtonLink && !expired) ?
                        <Redirect url={ promo.enlaceButtonLink } className="link" >
                            { promo.textoButtonLink }
                        </Redirect> : <div className="space"></div>
                    }
                    <div className={`o-section-info-promo_buttons`}>
                    {
                        (promo.textoDeLlamadaALaAccion && !expired) &&
                        <Redirect url={ `${ promo.llamadaALaAccion }` } className="button">
                            { promo.textoDeLlamadaALaAccion }
                        </Redirect>          
                    }
                    {
                        (promo.textoBotonSecundario  && promo.llamadaALaAccion && !expired) && 
                        <Redirect url={ promo.enlaceBotonSecundario } className="button outline-dark">
                                { promo.textoBotonSecundario }
                        </Redirect>
                    }
                    </div>
                    
                    {
                        !expired && 
                        <SharedSocial redes={ promo.redesEnLasQueSeComparte } link={ `${siteUrl}/promociones/${ promo.slug }` } />
                    }
                </div>
            </div>
        </div>
    )
}

export default SectionInfoPromo
